<template>
  <!-- 授课老师、助教老师选择组件 -->
  <div class="teacher-select">
    <!-- 选择角色 -->
    <el-select v-model="xRole" placeholder="请选择角色" filterable style="margin-right:10px; width:110px"
      @change="changeRole" :disabled="isDisable">
      <el-option :label="item.name" :value="item.val" v-for="(item, index) in roleOption" :key="index"></el-option>
    </el-select>
    <!-- 根据角色选择老师 -->
    <el-select v-model="xSelected" placeholder="请选择授课老师" filterable @change="changeSelected" :disabled="isDisable"
      clearable>
      <el-option :label="item.name" :value="item.id" v-for="(item, index) in list" :key="index"></el-option>
    </el-select>
  </div>
</template>

<script>
  export default {
    props: {
      // 请求类型 （授课老师，助教老师）
      requestType: {
        required: true,
        type: String,
      },
      // 请求所用课程id
      userGroup: {
        type: Array
      },
      // 回显时的身份
      role: {
        type: String,
      },
      // 回显时选中教师id
      selected: {
        // type: Number
      },
      isDisabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isDisable: false,
        list: "",
        xRole: 'expert',
        xSelected: undefined,
        roleOption: [{
          name: '专家',
          val: 'expert'
        }, {
          name: '助教',
          val: 'assistant'
        }, {
          name: '参训教师',
          val: 'teacher'
        }, {
          name: '管理者',
          val: 'leader'
        }]
      }
    },
    computed: {},
    watch: {
      isDisabled(newVal, oldVal) {
        if (newVal) {
          this.isDisable = true
        }
      },
      selected: {
        handler(newVal, oldVal) {
          if (newVal) this.xSelected = newVal;
        },
        immediate: true,
        deep: true
      },
      role(newVal, oldVal) {
        if (newVal) {
          this.xRole = newVal;
          this.getList();
        }
      },
      userGroup(newVal, oldVal) {
        // console.log(newVal)
        if (JSON.stringify(newVal) == '[]') {
          this.list = [];
          this.changeSelected(undefined);
          return;
        }
        if (newVal) {
          if (newVal === oldVal) return;
          this.getList();
        }
      }
    },
    methods: {
      // 改变选中老师
      changeSelected(val) {
        this.xSelected = val;
        this.$emit('teacherSelect', {
          role: this.xRole,
          teacherId: this.xSelected,
          type: this.requestType
        });
      },
      // 改变身份
      changeRole(val) {
        this.xRole = val;
        this.xSelected = undefined;
        this.getList();
      },
      //获取老师列表
      async getList() {
        this.list = [];
        let params = {
          userGroupIds: this.userGroup,
          type: this.xRole
        };
        if (JSON.stringify(params.userGroupIds) == '[]' || !params.userGroupIds) return;
        let resData = await this.$Api.Course.TeacherList(params);
        // console.log(resData);
        this.list = resData.data;
        let flag = resData.data.find(item => item.id == this.xSelected);
        if (!flag) this.changeSelected(undefined);
      },
    },
    mounted() {
      this.isDisable = this.isDisabled;
      this.getList();
    },
  }
</script>

<style>

</style>